import { SpeedDial, Badge, useTheme } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useTasks } from '../../hooks/useTasks';

interface TasksSpeedDialProps {
  onClick: () => void;
}

const TasksSpeedDial = ({ onClick }: TasksSpeedDialProps) => {
  const theme = useTheme();

  // Get all the task data from context
  const {
    tasks: apiTasks,
    completedTaskIds
  } = useTasks();

  // Get active count directly
  const activeTaskCount = apiTasks.length - completedTaskIds.size;

  return (
    <SpeedDial
      ariaLabel="View Tasks"
      sx={{
        position: 'fixed',
        bottom: 154,
        right: 16,
        zIndex: theme.zIndex.speedDial,
      }}
      icon={
        <Badge 
          badgeContent={activeTaskCount} 
          color="warning"
          max={99}
          invisible={activeTaskCount === 0}
          sx={{
            '& .MuiBadge-badge': {
              right: 4,
              top: 4,
            }
          }}
        >
          <AssignmentIcon />
        </Badge>
      }
      onClick={onClick}
    />
  );
};

export default TasksSpeedDial;